import { SummaryRow } from '../../../Summary/SummaryRow';

import { Q } from '../../../../store/student/types';
import { IRisk } from '../../../../types';
import { partnerVisaStatusSummaryRow } from '../../../pages/history/qPage3/utils';
import { useTranslation } from "react-i18next";

interface Props {
  showRisks: boolean;
  hasDependents?: string;
  hasPartner?: string;
  hasChildren?: string;
  partnerVisaStatus?: string;
  childrenNum: string;
  riskList?: IRisk['historyRisk']['travellersAndDependants'];
}

function UpcomingVisaAndDependants({
  showRisks,
  hasDependents,
  hasPartner,
  partnerVisaStatus,
  hasChildren,
  childrenNum,
  riskList = [],
}: Props) {
    const { t } = useTranslation('forms.visa');
  return (
    <>
      <SummaryRow
        key="hasDependents"
        label={t('forms.visa:anyoneComingWithYou')}
        fullLabel="Do you have anyone coming with you to the UK?"
        value={hasDependents}
        isRisk={showRisks && riskList.includes(Q.FAMILY_MEMBERS_TRAVELLING)}
      />

      <SummaryRow
        key="spouse"
        label={t('forms.visa:partnerApplyingForAUkVisaOrIsAlr')}
        fullLabel="Do you have a partner that is either applying for a UK visa or has a UK visa?"
        value={hasPartner}
        isRisk={showRisks && riskList.includes(Q.SPOUSE_TRAVELLING)}
      />

      {hasPartner === 'Yes' && (
        <SummaryRow
          key="partner"
          label={t('forms.visa:partnerIs')}
          fullLabel="My partner is..."
          value={partnerVisaStatusSummaryRow(partnerVisaStatus)}
          isRisk={showRisks && riskList.includes(Q.PARTNER_VISA_STATUS)}
        />
      )}

      <SummaryRow
        key="children"
        label={t('forms.visa:applyingForAStudentVisaWithDepen')}
        fullLabel="Are you applying for your Student visa with dependant children?"
        value={hasChildren}
        isRisk={showRisks && riskList.includes(Q.CHILDREN_TRAVELLING)}
      />

      {hasDependents === 'Yes' && hasChildren === 'Yes' && (
        <SummaryRow
          key="childrenNum"
          label={t('forms.visa:numOfChildren')}
          fullLabel="How many children?"
          value={childrenNum}
          isRisk={showRisks && riskList.includes(Q.CHILDREN_TRAVELLING_NUMBER)}
        />
      )}
    </>
  );
}

export default UpcomingVisaAndDependants;
